import { Discount as DiscountIcon } from '@mafc/icon';
import { Box, Flex, LinearProgress } from '@mafc/trolly';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import Card from 'common/Card';
import { CardText, CardTitle } from 'common/Card/Card.style';
import LinkActionButton from 'common/LinkActionButton';
import useAction from 'hooks/useAction';
import useDrawerControls from 'hooks/useDrawerControls';
import { AppliedVoucher, VoucherType } from 'network/response/ICart';
import { ICartState } from 'pages/Cart/redux/reducer';
import { ICheckoutState } from 'pages/Checkout/redux/reducer';
import { removePromo } from 'pages/Checkout/redux/actions/promo.action';
import PromoCodeDrawer from '../PromoCodeDrawer';
import { getDiscountAmount } from './Promo.helper';
import { ILoyaltyPointState } from '../LoyaltyPoints/redux/LoyaltyPoints.reducer';

const Promo = () => {
  const { t } = useTranslation();
  const { isOpen, openDrawer, closeDrawer } = useDrawerControls();
  const [removePromoAction] = useAction(removePromo);

  const {
    appliedPromo,
    loading,
    isToggleSwitchedOn,
  }: {
    appliedPromo: AppliedVoucher | null;
    loading: boolean;
    isToggleSwitchedOn: boolean;
  } = useSelector(
    (state: { cart: ICartState; checkout: ICheckoutState; loyalty: ILoyaltyPointState }) => {
      return {
        appliedPromo: state.cart.cartData.appliedVouchers
          ? state.cart.cartData.appliedVouchers[0]
          : null,
        loading: state.checkout.promo.loading,
        isToggleSwitchedOn:
          state.loyalty && state.cart.cartData.totalPrice.value === 0
            ? state.loyalty.isToggleSwitchedOn
            : false,
      };
    }
  );

  const clickHandler = () => {
    if (isToggleSwitchedOn) {
      return;
    }
    if (appliedPromo) {
      removePromoAction(appliedPromo.voucherCode, t);
    } else {
      openDrawer();
    }
  };

  const promoCodeText =
    appliedPromo && appliedPromo.type !== VoucherType.bin ? `${appliedPromo.code} - ` : '';

  return (
    <Card testId="promo_code_card" variant="scattered">
      <Flex>
        <DiscountIcon />

        <Box ml={3}>
          <CardTitle>
            {appliedPromo ? t('promo.voucherCode') : t('promo.applyAPromoCode')}
          </CardTitle>

          <CardText>
            {promoCodeText}
            {appliedPromo
              ? t('promo.offMessage', {
                  discount: getDiscountAmount(appliedPromo),
                })
              : t('promo.enterAPromoCode')}
          </CardText>
        </Box>
      </Flex>

      <LinkActionButton
        label={appliedPromo ? t('remove') : t('promo.apply')}
        onClick={clickHandler}
        dataTestId="promo-action-btn"
        disabled={isToggleSwitchedOn}
      />
      {loading && <LinearProgress position="bottom" />}

      {isOpen && <PromoCodeDrawer isOpen={isOpen} closeDrawer={closeDrawer} />}
    </Card>
  );
};

export default Promo;
